export default {
    methods: {
        findDocumentStatusIconStyles(document) {
            return {
                'fa-check': document.status === 'approved',
                'fa-clock': document.status === 'pending',
                'fa-times': document.status !== 'approved' && document.status !== 'pending',
                'text-green': document.status === 'approved',
                'text-orange': document.status === 'expired' || document.status === 'pending',
                'text-red': document.status === 'missing' || document.status === 'rejected',
            }
        },

        findDocumentStatusStyles(document) {
            return {
                 'text-red': document.status === 'missing' || document.status === 'rejected',
                 'text-orange': document.status === 'expired' || document.status === 'pending',
                 'text-green': document.status === 'approved'
             }
        }
    }
}